﻿import {translation} from "@2d-front-monorepo/core";
import {PermitResult} from "@2d-front-monorepo/permits-business";
import {PermitTranslations} from "@2d-front-monorepo/shared-translations";
import {JSX} from "react";
import {formatCurrency} from "../../../functions";

export function TotalComponent({permit}: { permit: PermitResult }): JSX.Element {
	const total =
		permit.payment?.operation?.step?.total ??
		permit.payment?.billing?.step?.total

	if (total == null || total == 0) {
		return <></>;
	}

	return <footer className="layout horizontal">
		<span className="flex">{translation(PermitTranslations.price)}</span>
		<span>{formatCurrency(total)}</span>
	</footer>
}
